export class DeliveryDiscountBranchesMiniEntity {
  id?: number
  name?: string | null
}
